import apiClient from "@/app/api/client";

/**
 * Xodim → hudud teskari qidiruvining bir qatori.
 *
 * ⚠️ `tur` — BIRIKTIRISH turi (`employee_zones.tur`), hududning `tur`
 * ustuni EMAS.
 *
 * ⚠️ **`amalda` ni SERVER hisoblaydi** (`settings.timezone` bo'yicha
 * biznes sanasi). Uni brauzer sanasi bilan qayta hisoblamang: yarim
 * tunda va boshqa vaqt zonasidagi brauzerda natija farq qilardi.
 * `validTo === null` soddalashtirishi ham NOTO'G'RI — muddatli
 * biriktirishda `validTo` KELAJAKDA bo'lishi mumkin va u hali amalda.
 */
export interface EmployeeZoneAssignment {
	id: string;
	zoneId: string;
	zoneName: string;
	tur: string;
	validFrom: string;
	validTo: string | null;
	amalda: boolean;
	createdAt: string;
}

/**
 * `GET /employees/{id}/zones` — xodimning hudud biriktirishlari.
 *
 * ⚠️ **URL butun frontend'da FAQAT shu yerda yoziladi.** Marshrut
 * `employees` resursida (`employee-zones.routes.ts:24`), sxemasi esa
 * `zoneAssignmentTypeSchema` ni `zones` dan import qiladi — ya'ni
 * «qaysi resursniki» degan savol ikki javobga ega va URL ni ikkinchi
 * marta yozish ularni jimgina ajratardi.
 *
 * ⚠️ **Javob SAHIFALANMAGAN** — `createSuccessSchema(z.array(...))`,
 * ya'ni `{ items, meta }` EMAS
 * (`employee-zones.schemas.ts:38-41`). `response.data.data.items` deb
 * o'qilsa `undefined` kelib, ustun jimgina «—» bo'lib qolardi.
 */
export async function fetchEmployeeZones(employeeId: string): Promise<EmployeeZoneAssignment[]> {
	const response = await apiClient.get<{ success: true; data: EmployeeZoneAssignment[] }>(
		`/employees/${employeeId}/zones`
	);

	return response.data.data;
}
